export default __webpack_public_path__ + "static/media/thumbnail-mien.d3285a9d.png";